import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FunctionComponent } from "react";

import { IProps } from "./icon-title.types";

/**
 * Display an icon with a title next to it
 * @param props.title The title to display
 * @param props.icon  The icon to display
 */
const IconTitle: FunctionComponent<IProps> = ({ title, icon }) => {
    return (
        <div className="icon-title">
            <FontAwesomeIcon name={title} icon={icon} />
            {title}
        </div>
    );
};

export default IconTitle;
